import { getWallConfig } from '@services/config';
import { getHotspotCurrentPlan } from '@services/products';
import { wallService } from '@services/products/wall';

import { WallType } from '@app-types/config';
import { SearchParamsType } from '@app-types/page';

import { AccessoryImageThumbor } from '@components/image-thumbor';

import { HotspotWall } from './wall-hotspot';

interface HotspotWallServerProps {
    searchParams?: SearchParamsType;
}

const type = WallType.HOTSPOT;

export async function HotspotWallServer({ searchParams }: Readonly<HotspotWallServerProps>) {
    const wallConfig = getWallConfig(type);
    const page = typeof searchParams?.page === 'string' ? Number(searchParams.page) : 1;
    const urlSearchParams = new URLSearchParams(searchParams);

    const planWithProvenance = await getHotspotCurrentPlan(urlSearchParams);

    const { products, count } = await wallService
        .getHotspotProducts({
            sort: 'meilleures-ventes',
            page,
            limit: wallConfig.productByPage,
            plan: planWithProvenance.plan?.gencode ?? (planWithProvenance.plan as undefined | null),
        })
        .catch(() => ({ products: [], count: 0 }));

    return (
        <HotspotWall
            title={wallConfig.baseTitle}
            products={products}
            pageSize={wallConfig.productByPage}
            count={count}
            wallConfig={wallConfig}
            startPage={page}
            searchParams={searchParams}
            imageAs={AccessoryImageThumbor}
            plan={planWithProvenance}
            trackingData={{
                page: 'Mur_hotspot_tablette',
                pageCategory: 'Liste_produits',
                isB2B: false,
                eCommerceStep: 'Liste_produits',
            }}
        />
    );
}
